import { render, staticRenderFns } from "./bom-sheet.vue?vue&type=template&id=7e65069a&scoped=true&"
import script from "./bom-sheet.vue?vue&type=script&lang=js&"
export * from "./bom-sheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e65069a",
  null
  
)

export default component.exports